
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C10000"}},[_c('path',{attrs:{"d":"M0 0h96v48H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v24H0z"}}),_c('path',{attrs:{"d":"M17 3h6v18h-6z"}}),_c('path',{attrs:{"d":"M11 9h18v6H11z"}})])])
          )
        }
      }
    